import {
  TURNUP_EVEN,
  TURNUP_ONE_MAIN,
  TURNUP_QUINSTREET
} from 'helpers/Constants';
import {
  TurnupBody,
  TurnupFooter,
  TurnupHeader
} from 'registration/TurnupContent';
import { useSelector } from 'react-redux';
import { WHITE_BACKGROUND } from 'styles/Colors';
import React from 'react';
import RebrandTextWithCheckbox from 'components/rebrand/RebrandTextWithCheckbox';

const VALID_TURNUP_VENDORS = [TURNUP_EVEN, TURNUP_ONE_MAIN, TURNUP_QUINSTREET];

const containerStyle = {
  borderWidth: '3px',
  backgroundColor: WHITE_BACKGROUND
};

function TurnupDisclosures() {
  const vendor = useSelector((store) => store.productTurnupVendor);

  if (!vendor || !VALID_TURNUP_VENDORS.includes(vendor)) {
    return null;
  }

  return (
    <RebrandTextWithCheckbox
      header={<TurnupHeader vendor={vendor} />}
      body={<TurnupBody vendor={vendor} />}
      checkBoxLabel={<TurnupFooter vendor={vendor} />}
      additionalStyle={{ containerStyle }}
      id='turnUpDisclosure'
    />
  );
}

export default TurnupDisclosures;
